<div class="request-notes">
    <div *ngIf="notes.length > 0; else notesEmpty">
        <ng-container *ngIf="(notes
              | noteUsernameFilter: usernameFilterValue
              | noteCreationDateFilter: creationDateFilterValue
              | noteLastModificationDateFilter: lastModificationDateFilterValue
              | noteTextFilter: textFilterValue) as filteredNotes">
            <div class="table-container table-scroll">
                <table class="table table-hover table-notes">
                    <thead>
                    <tr class="column-titles">
                        <th>Utente</th>
                        <th>Data creazione</th>
                        <th>Ultima modifica</th>
                        <th class="col-wrap">Testo</th>
                        <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                    </tr>
                    <tr class="column-filters">
                        <th>
                            <input [(ngModel)]="usernameFilterValue"
                                   type="text"
                                   class="form-control form-white column-filter-control"
                                   placeholder="Utente"
                                   aria-label="Filtra per utente">
                        </th>
                        <th>
                            <input [(ngModel)]="creationDateFilterValue"
                                   type="text"
                                   class="form-control form-white column-filter-control"
                                   placeholder="Data"
                                   aria-label="Filtra per data di creazione">
                        </th>
                        <th>
                            <input [(ngModel)]="lastModificationDateFilterValue"
                                   type="text"
                                   class="form-control form-white column-filter-control"
                                   placeholder="Data"
                                   aria-label="Filtra per data di ultima modifica">
                        </th>
                        <th class="col-wrap">
                            <input [(ngModel)]="textFilterValue"
                                   type="text"
                                   class="form-control form-white column-filter-control"
                                   placeholder="Testo"
                                   aria-label="Filtra per testo">
                        </th>
                        <th class="col-sticky col-sticky-actions"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngIf="filteredNotes.length === 0">
                        <td colspan="5" class="filtered-empty-state">
                            <div class="filtered-empty-pin">
                                Nessun risultato con i filtri attuali.
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let note of filteredNotes">
                        <td>{{ note.user?.Username || '-' }}</td>
                        <td>{{ note.CreationDate | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td>{{ note.LastModificationDate | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td class="col-wrap">
                            <textarea *ngIf="editingNoteId === note.IDNote"
                                      class="form-control form-white note-edit-textarea"
                                      rows="4"
                                      [(ngModel)]="editingText"></textarea>
                            <span *ngIf="editingNoteId !== note.IDNote" class="note-text">{{ note.Text }}</span>
                        </td>
                        <td class="text-right notes-actions-cell col-sticky col-sticky-actions">
                            <ng-container *ngIf="editingNoteId === note.IDNote; else noteActions">
                                <button type="button"
                                        class="btn btn-sm btn-primary note-inline-btn"
                                        (click)="saveNote(note)"
                                        [disabled]="saving || !editingText.trim()">
                                    Salva
                                </button>
                                <button type="button"
                                        class="btn btn-sm btn-secondary note-inline-btn"
                                        (click)="cancelEdit()"
                                        [disabled]="saving">
                                    Annulla
                                </button>
                            </ng-container>
                            <ng-template #noteActions>
                                <div ngbDropdown
                                     [autoClose]="'outside'"
                                     container="body"
                                     placement="bottom-right"
                                     class="notes-actions-dropdown">
                                    <button type="button"
                                            class="btn btn-secondary btn-sm dropdown-toggle"
                                            ngbDropdownToggle
                                            aria-haspopup="true"
                                            aria-expanded="false">
                                        Azioni
                                    </button>
                                    <div ngbDropdownMenu class="dropdown-menu notes-actions-menu">
                                        <button (click)="startEdit(note)" class="dropdown-item" type="button">
                                            <i class="fa fa-pencil"></i>Modifica
                                        </button>
                                        <button (click)="openDeleteNoteModal(note)" class="dropdown-item" type="button">
                                            <i class="fa fa-trash-o"></i>Elimina
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>
    </div>
    <ng-template #notesEmpty>
        <div class="notes-empty">
            Nessuna nota presente.
        </div>
    </ng-template>
</div>
